import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddPlayListItemButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/play_list_items/create?playList=${record['@id']}`}
    label="Add a play list item"
    title="Add a play list item"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddPlayListItemButton);
